import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { AnimationProp, FontAwesomeModule, SizeProp } from '@fortawesome/angular-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'orbit-fa-icon',
  standalone: true,
  imports: [FontAwesomeModule],
  templateUrl: './fa-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaIconComponent {
  public iconName = input.required<IconProp>();
  public iconColor = input<string | undefined>(undefined);
  public iconSize = input<SizeProp | undefined>('1x');
  public animation = input<AnimationProp | undefined>(undefined);
}
